import React from 'react'

import Gal1 from '../Images/SUSHENA HOSPITAL & RAJ DIAGNOSTIC CENTRE -01.png'
import gal2 from '../Images/SUSHENA HOSPITAL & RAJ DIAGNOSTIC CENTRE -02.png'
import gal3 from '../Images/SUSHENA HOSPITAL & RAJ DIAGNOSTIC CENTRE -03.png'
import gal4 from '../Images/SUSHENA HOSPITAL & RAJ DIAGNOSTIC CENTRE -04.png'
import gal5 from '../Images/SUSHENA HOSPITAL & RAJ DIAGNOSTIC CENTRE -05.png'
import gal6 from '../Images/SUSHENA HOSPITAL & RAJ DIAGNOSTIC CENTRE -06.png'
import NEW from '../Images/eys.jpg'

const Gallery = () => {
  return (
    <div>
      <div className='gallery'>

        <div className='gallery2'>
          <img src={Gal1} />
        </div>

        <div className='gallery2'>
          <img src={gal2} />
        </div>


        <div className='gallery2'>
          <img src={gal3} />
        </div>

      </div>

      <div className='gallery'>

        <div className='gallery2'>
          <img src={gal4} />
        </div>

        <div className='gallery2'>
          <img src={gal5} />
        </div>


        <div className='gallery2'>
          <img src={gal6} />
        </div>

      </div>



      <div className='gallery'>

        <div className='gallery2'>
          <img src={NEW} />
        </div>

        

      </div>






    </div>
  )
}

export default Gallery